export default function ({ route, redirect }) {
    const allowedRoutes = ['/roadshow-taiwan', '/roadshow-taiwan-2', '/roadshow-singapore', '/hu/roadshow-budapest', '/ar/blog/gcc-residents', '/roadshow-hong-kong'];    
  
    if (!allowedRoutes.includes(route.path)) {
      return redirect('/roadshow-taiwan');
    }
  }